import * as React from 'react';
import Trigger from 'rc-trigger';
import classNames from 'classnames';
import raf from 'rc-util/lib/raf';
import { MenuContext } from '../context/MenuContext';
import { placements, placementsRtl } from '../placements';
import { getMotion } from '../utils/motionUtil';
const popupPlacementMap = {
    horizontal: 'bottomCenter',
    vertical: 'rightTop',
    'vertical-left': 'rightTop',
    'vertical-right': 'leftTop'
};
export default function PopupTrigger({ prefixCls, visible, children, popup, popupClassName, popupOffset, popupPlacement: customPopupPlacement, disabled, mode, onVisibleChange }) {
    const { getPopupContainer, rtl, subMenuOpenDelay, subMenuCloseDelay, builtinPlacements, triggerSubMenuAction, forceSubMenuRender, 
    // Motion
    motion, defaultMotions } = React.useContext(MenuContext);
    const [innerVisible, setInnerVisible] = React.useState(false);
    const placement = rtl
        ? Object.assign(Object.assign({}, placementsRtl), builtinPlacements) : Object.assign(Object.assign({}, placements), builtinPlacements);
    const popupPlacement = customPopupPlacement || popupPlacementMap[mode];
    const targetMotion = getMotion(mode, motion, defaultMotions);
    const mergedMotion = Object.assign(Object.assign({}, targetMotion), { leavedClassName: `${prefixCls}-hidden`, removeOnLeave: false, motionAppear: true });
    // Delay to change visible
    const visibleRef = React.useRef();
    React.useEffect(() => {
        visibleRef.current = raf(() => {
            setInnerVisible(visible);
        });
        return () => {
            raf.cancel(visibleRef.current);
        };
    }, [visible]);
    return (<Trigger prefixCls={prefixCls} popupClassName={classNames(`${prefixCls}-popup`, {
            [`${prefixCls}-rtl`]: rtl
        }, popupClassName)} stretch={mode === 'horizontal' ? 'minWidth' : null} getPopupContainer={getPopupContainer} builtinPlacements={placement} popupPlacement={popupPlacement} popupVisible={innerVisible} popup={popup} popupAlign={popupOffset && { offset: popupOffset }} action={disabled ? [] : [triggerSubMenuAction]} mouseEnterDelay={subMenuOpenDelay} mouseLeaveDelay={subMenuCloseDelay} onPopupVisibleChange={onVisibleChange} forceRender={forceSubMenuRender} popupMotion={mergedMotion}>
            {children}
        </Trigger>);
}
